import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {MatInputModule} from '@angular/material/input';
import {ConfirmDialogComponent} from './confirm-dialog.component';

@NgModule({
  imports: ConfirmDialogModule.IMPORTS,
  declarations: ConfirmDialogModule.DECLARATIONS,
  exports: ConfirmDialogModule.DECLARATIONS
})
export class ConfirmDialogModule {
  public static readonly IMPORTS: any[] = [CommonModule, MatDialogModule, MatButtonModule, MatInputModule];

  public static readonly DECLARATIONS: any[] = [ConfirmDialogComponent];
}
